import type { ReactNode } from "react";

interface PreviewUserSectionProps {
  children: ReactNode;
}

export const PreviewUserSection = ({ children }: PreviewUserSectionProps) => (
  <div className="border-default border-t bg-gray-100 p-7">
    <div className="flex items-center justify-between gap-4">{children}</div>
  </div>
);
